'use strict';

import _ from 'lodash';
import React, {PropTypes} from 'react';
import DropDownMenu from '../../../../common/components/c_DropDownMenu';
import TextField from '../../../../common/components/c_TextField';
import MaskedTextField from '../../../../common/components/c_MaskedTextField';
import TextArea from '../../../../common/components/c_TextArea';
import FlatButton from '../../../../common/components/c_FlatButton';
import RatingStars from '../../../../common/components/c_RatingStars';
import MaskedInput, {MaskTypes} from '../../../../common/components/MaskedInput';
import { monthYear } from '../../../../lib/prettyDate';
import { connect } from 'react-redux';

// styling obj
const completeButtonStyle = {
  border: 'solid 1px #808080',
  width: '296px',
  height: '45px'
};

const textFieldStyle = {
  margin: '-8px 0 2px',
  width: '100%',
  height: '100px',
  minHeight: '100px',
  lineHeight: '1.63',
};

@connect((store) => (
    {
      staticData: store.staticData,
    }
  )
)
export default class ReferenceItem extends React.Component {
  static propTypes = {
    staticData: PropTypes.object.isRequired,
    updateTempState: PropTypes.func.isRequired,
    onComplete: PropTypes.func.isRequired,
    updateReference: PropTypes.func.isRequired,
    reference: PropTypes.object.isRequired,
    referenceType: PropTypes.string.isRequired,
    questions: PropTypes.array.isRequired,
    applicant: PropTypes.object.isRequired,
    referenceClientId: PropTypes.string.isRequired,
    referenceRelationshipTypes: PropTypes.array.isRequired
  };

  constructor(props, context) {
    super(props, context);
  }

  componentWillMount() {
    this.state = {
      reference: this.props.reference
    };
  }

  getReferenceType() {
    const { referenceTypes } = this.props.staticData;
    return referenceTypes.find(referenceType => referenceType.name === this.props.referenceType);
  }

  isProfessional(referenceType = this.getReferenceType()) {
    return (referenceType.name === 'Professional');
  }

  isAdditional(referenceType = this.getReferenceType()) {
    return (referenceType.name === 'Additional');
  }

  newInterview() {
    const referenceType = this.getReferenceType();
    return {
      applicantId: this.props.applicant.profile.id,
      workExperienceClientId: this.isProfessional(referenceType) ? this.props.reference.clientId : null,
      referencesClientId: this.isAdditional(referenceType) ? this.props.reference.clientId : null,
      referenceType: referenceType.id,
      complete: false,
      isNew: true,
      answers: []
    };
  }

  replaceTokens(label, tokens) {
    return _.reduce(tokens, (newLabel, token) => newLabel.replace(token[0], token[1]), label);
  }

  handleAnswerChange(questionId, event, value) {
    const newVal = _.isBoolean(value) ? (value ? 'Yes' : 'No') : value;
    const interviewState = !_.isEmpty(this.props.reference.interview) ? {...this.props.reference.interview} : this.newInterview();
    const index = _.findIndex(interviewState.answers, (answer) => answer.questionId === questionId);
    if (~index) {
      interviewState.answers[index].answer = newVal;
    }
    else {
      interviewState.answers.push({questionId, answer: newVal});
    }
    interviewState.isDirty = true;
    this.props.updateTempState(this.props.referenceClientId, interviewState);
  }

  handleInterviewChange(prop, event, value) {
    const interviewState = this.props.reference.interview ? {...this.props.reference.interview} : this.newInterview();
    interviewState[prop] = (prop === 'complete') ? true : value;
    interviewState.isDirty = true;
    this.props.updateTempState(this.props.referenceClientId, interviewState);
    if (prop === 'complete') {
      setTimeout(() => this.props.onComplete(), 0);
    }
  }

  handleReferenceChange(prop) {
    return (event, value) => {
      const newReference = this.state.reference;
      newReference.reference[prop] = value;
      this.setState({reference: newReference});
    };
  }

  handleReferenceUpdate = () => {
    this.props.updateReference(this.state.reference, this.props.referenceType);
  }

  renderTextArea(question, answers) {
    const answer = _.find(answers, {questionId: question.id}) || {};
    return (
      <TextArea
        style={textFieldStyle}
        value={(answer || {}).answer}
        onChange={this.handleAnswerChange.bind(this, question.id)}/>
    );
  }

  renderYesNo(question, answers) {
    const answer = _.find(answers, {questionId: question.id}) || {};
    const options = [{value: 'Yes', primaryText: 'Yes'}, {value: 'No', primaryText: 'No'}];
    return (
      <DropDownMenu
        data-id={`question ${question.id}`}
        defaultValue={(answer || {}).answer}
        menuItems={options}
        onChange={this.handleAnswerChange.bind(this, question.id)} />
    );
  }

  render() {
    const tokens = [['[applicant_name]', `${this.props.applicant.user.firstName} ${this.props.applicant.user.lastName}`],
                    ['[job_title]', this.props.reference.title]];
    const notSpecified =   'Not specified';
    const referenceType = this.getReferenceType(this.props.referenceType);
    const answers = this.props.reference.interview && this.props.reference.interview.answers || [];
    const questions = _.filter(this.props.questions, q => q.referenceType === referenceType.id || q.referenceType === null);
    const valid = (_.filter(answers, a => a.answer.length).length === questions.length) && this.props.reference.interview.rating && this.props.reference.interview.comments;
    const isComplete = this.props.reference.interview.complete && !this.props.reference.interview.isDirty;
    const relationship = _.find(this.props.referenceRelationshipTypes, {id: this.props.reference.reference.relationshipId});
    if (relationship && relationship.name && ~relationship.name.indexOf('Other')) {
      relationship.name = this.props.reference.reference.relationshipOther;
    }

    return (
      <div className='explanation-of-wahve'>
        <div className='reference-container'>
          <div className='reference-info-container'>
            <TextField
              value={this.isProfessional(referenceType) ? this.props.reference.reference.supervisorName : this.props.reference.name}
              floatingLabelText={this.isProfessional(referenceType) ? "Supervisor's Name" : "Reference's Name"}
              disabled
            />
            {
              this.isProfessional(referenceType)
              &&
              <TextField
                value={this.props.reference.name || notSpecified}
                floatingLabelText={'Company Name'}
                disabled
              />
            }
            {
              this.isAdditional(referenceType)
              &&
              <TextField
                value={(relationship || {}).name || notSpecified}
                floatingLabelText={'Relationship'}
                disabled
              />
            }
            <TextField
              value={this.props.reference.title || notSpecified}
              floatingLabelText={'Position/Title'}
              disabled
            />
            {
              this.isProfessional(referenceType)
              &&
              <TextField
                className={'email'}
                value={this.state.reference.reference.supervisorEmail || notSpecified}
                floatingLabelText={"Supervisor's Email"}
                onBlur={this.handleReferenceUpdate.bind(this)}
                onChange={this.handleReferenceChange('supervisorEmail')}
              />
            }
            <MaskedTextField
              mask='(999) 999-9999'
              className='phone-number'
              hideMaskChar
              defaultValue={this.isProfessional(referenceType) ? this.state.reference.reference.supervisorPhoneNumber : this.state.reference.reference.phoneNumber}
              floatingLabelText={this.isProfessional(referenceType) ? "Supervisor's Phone Number" : "Reference's Phone Number"}
              onBlur={this.handleReferenceUpdate.bind(this)}
              onChange={this.handleReferenceChange(this.isProfessional(referenceType) ? 'supervisorPhoneNumber' : 'phoneNumber')}
            />
            {
              this.isAdditional(referenceType)
              &&
              <TextField
                value={this.props.reference.reference.yearsKnown || notSpecified}
                floatingLabelText={'Years Known'}
                disabled
              />
            }
            {
              this.isProfessional(referenceType)
              &&
              <MaskedInput
                data-id={'Employment Start'}
                className={'reference-date'}
                disabled={true}
                type={MaskTypes.monthYear}
                value={monthYear(this.props.reference.reference.employmentStart)}
                floatingLabelText={'Employment Start'}
                disabled
              />
            }
            {
              this.isProfessional(referenceType)
              &&
              <MaskedInput
                data-id={'Employment End'}
                className={'reference-date'}
                disabled
                type={MaskTypes.monthYear}
                value={this.props.reference.reference.current ? 'Current' : monthYear(this.props.reference.reference.employmentEnd)}
                floatingLabelText={'Employment End'}
                disabled
              />
            }
            </div>
            <div className='reference-questions-container'>
            {
              _.map(_.sortBy(questions, 'order'), (item, index) =>
                <div key={index} className='reference-question'>
                  <div>{this.replaceTokens(item.question, tokens)}</div>
                  <div>
                    {
                      (item.questionType === 2) ? this.renderYesNo(item, answers) : this.renderTextArea(item, answers)
                    }
                  </div>
                </div>
              )
            }
            </div>
            <div className='reference-questions-container'>
              <div className='reference-question'>
                <RatingStars
                  data-id={`Rating`}
                  floatingLabelText={'Reference Rating'}
                  value={(this.props.reference.interview || {}).rating}
                  onChange={this.handleInterviewChange.bind(this, 'rating')}
                  />
              </div>
              <div className='reference-question'>
                <div>Final Comments</div>
                <TextArea
                  data-id='Comments'
                  style={textFieldStyle}
                  value={(this.props.reference.interview || {}).comments}
                  onChange={this.handleInterviewChange.bind(this, 'comments')}
                />
              </div>
          </div>
          <FlatButton
            className={'complete-button'}
            disabled={!valid || isComplete}
            label={'Complete'}
            data-id={'Complete'}
            style={completeButtonStyle}
            onClick={this.handleInterviewChange.bind(this, 'complete')}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/ReferencesList/referenceItem/index.js